import React from 'react';

const SortIcon = () => (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.819387 5.14272H7.20172C7.90904 5.14272 8.26743 4.21862 7.76588 3.67969L4.59591 0.251116C4.28415 -0.0837054 3.77636 -0.0837054 3.4646 0.251116L0.252085 3.68022C-0.24658 4.21862 0.111868 5.14272 0.819387 5.14272ZM4.01055 0.856205L7.18052 4.28558H0.798187L4.01055 0.856205Z"
      fill="currentColor"
    />
    <path
      d="M7.18057 6.85693H0.798235C0.0909163 6.85693 -0.267482 7.78104 0.234076 8.32024L3.40404 11.7488C3.7158 12.0836 4.22359 12.0836 4.53535 11.7488L7.70532 8.32024C8.26798 7.78104 7.90883 6.85693 7.18057 6.85693ZM4.0106 11.1426L0.819435 7.71408H7.20177L4.0106 11.1426Z"
      fill="currentColor"
    />
  </svg>
);

export default SortIcon;
